import { Dialog, DialogTitle, DialogContent, TextField, Checkbox, DialogActions, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { IServiceCheckListItem } from "../../interfaces/IServiceCheckListItem";

interface IProps {
    isCheckListItemDialogOpen: boolean;
    setIsCheckListItemDialogOpen: Function;
    checkListItem: IServiceCheckListItem;
    checkListItems: IServiceCheckListItem[];
    setCheckListItems: Function;
}

export const ServiceCheckListItemDialog: React.FC<IProps> = ({
    isCheckListItemDialogOpen,
    setIsCheckListItemDialogOpen,
    checkListItem,
    checkListItems,
    setCheckListItems,
}) => {
    const [editCheckListItem, setEditCheckListItem] = useState<IServiceCheckListItem>(checkListItem);
    const [isTitleValid, setIsTitleValid] = useState<boolean>(false);

    useEffect(() => {
        setIsTitleValid(editCheckListItem.title.trim() !== "");
    }, [editCheckListItem.title]);

    const handleSave = () => {
        let newItems;
        if (!checkListItems.find((x) => x.id === editCheckListItem.id)) {
            newItems = [...checkListItems, editCheckListItem];
        } else {
            newItems = checkListItems.map((item) => (item.id === editCheckListItem.id ? editCheckListItem : item));
        }

        setCheckListItems(newItems);
        setIsCheckListItemDialogOpen(false);
    };

    return (
        <>
            <Dialog open={isCheckListItemDialogOpen} onClose={() => setIsCheckListItemDialogOpen(false)} fullWidth>
                <DialogTitle>
                    {checkListItem.title === "" ? "Checklisteintrag hinzufügen" : `Checklisteintrag bearbeiten`}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        label="Titel"
                        error={!isTitleValid}
                        fullWidth
                        margin="normal"
                        value={editCheckListItem.title}
                        onChange={(e) =>
                            setEditCheckListItem({
                                ...editCheckListItem,
                                title: e.target.value,
                            })
                        }
                    />
                    <TextField
                        label="Beschreibung"
                        multiline
                        rows={3}
                        fullWidth
                        margin="normal"
                        value={editCheckListItem.description}
                        onChange={(e) =>
                            setEditCheckListItem({
                                ...editCheckListItem,
                                description: e.target.value,
                            })
                        }
                    />
                    <Checkbox
                        checked={editCheckListItem.isPhotoRequired}
                        onChange={(e) =>
                            setEditCheckListItem({
                                ...editCheckListItem,
                                isPhotoRequired: e.target.checked,
                            })
                        }
                    />
                    Foto benötigt
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsCheckListItemDialogOpen(false)} variant="outlined">
                        Abbrechen
                    </Button>
                    <Button
                        onClick={() => {
                            handleSave();
                        }}
                        disabled={!isTitleValid}
                        variant="contained"
                    >
                        Speichern
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
